import { SVGProps, Ref, forwardRef } from 'react';

export const EnvelopeOpenedOutlinedSize16Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={16}
            height={16}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <g>
                    <path d="M5.665 5.866h4.666v-1.4H5.665z" fill="currentColor" />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M2.999.5v3.223c-2.204.522-3 2.02-3 5.11v1.332c0 4 1.334 5.332 5.333 5.332h5.332c3.999 0 5.332-1.333 5.332-5.332V8.832c0-3.088-.795-4.587-3-5.109V.5zm8.598 1.4H4.399v5.978l3.599 1.495 3.599-1.495zm1.4 5.396 1.388-.576c-.138-.525-.331-.85-.546-1.064-.182-.182-.445-.35-.843-.48zm1.583.859-6.582 2.734-6.583-2.734q-.015.313-.015.677v1.333c0 1.922.338 2.758.756 3.176s1.254.756 3.176.756h5.332c1.922 0 2.758-.338 3.175-.756.418-.418.757-1.254.757-3.176V8.832q0-.364-.016-.677M1.61 6.72 3 7.296v-2.12c-.398.13-.66.298-.843.48-.214.215-.408.54-.545 1.064"
                        fill="currentColor"
                    />
                </g>
            </g>
        </svg>
    )
);
EnvelopeOpenedOutlinedSize16Glyph.displayName = 'EnvelopeOpenedOutlinedSize16Glyph';
